import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/useAuthStore';
import { useAutoLogout } from '../../utils/useAutoLogout';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();
  
  // Apply auto-logout for authenticated users (1440 minutes = 24 hours)
  useAutoLogout(1440);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/markets" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 